import {LinkPreviewService} from '../../libs/ui/src/index';
import {client} from '../apiService';
const _LinkPreviewService = new LinkPreviewService({client});
export {_LinkPreviewService as LinkPreviewService};
